import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = [...articles]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(3, 9);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            往期回顾
          </h2>
          <p className="text-sm text-foreground-500 mt-1">更多精彩爆料，一网打尽</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-primary-50/50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-28 h-20 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors font-heading text-sm line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span>{article.publishedAt}</span>
                  <span>{article.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}